import { GETOBJECTIVES_SUCCESS, GETOBJECTIVES_FAIL } from '../actionTypes';

const initialState = {
    user: []
};

const getObjectivesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GETOBJECTIVES_SUCCESS:
            return {
                ...state,
                isLoggedIn: true,
                user: action.payload.user,
            };
        case GETOBJECTIVES_FAIL:
            return {
                ...state,
                isLoggedIn: false,
                user: [],
            };
        default:
            break;
    }

    return state;
};

export default getObjectivesReducer;



